import { render, staticRenderFns } from "./Milestones.vue?vue&type=template&id=505fd375"
import script from "./Milestones.vue?vue&type=script&lang=ts"
export * from "./Milestones.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports